module.exports = __webpack_public_path__ + "static/image-modal-how-cost-0d63101dc90644e6634da6a2b421573b.png";